import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    pumperDad1: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '16%',
            y: '11%',
        },
        texture: 'sprite:/img/partials/pumpers/family/dad/1.json',
        particles: [
            {
                x: '67.2%',
                y: '18.6%',
                angle: 310,
                emit: false,
            },
            {
                x: '67.4%',
                y: '18.6%',
                angle: 310,
                emit: false,
            },
            {
                x: '67.1%',
                y: '18.6%',
                angle: 310,
                emit: true,
            },
            {
                x: '67.8%',
                y: '18.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '67.6%',
                y: '18.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '67.2%',
                y: '18.8%',
                angle: 310,
                emit: true,
            },
            {
                x: '67%',
                y: '18.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '66.6%',
                y: '18.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '66.9%',
                y: '18.3%',
                angle: 310,
                emit: true,
            },
            {
                x: '66.5%',
                y: '18.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '66.3%',
                y: '18.3%',
                angle: 310,
                emit: true,
            },
            {
                x: '67.3%',
                y: '18.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '67%',
                y: '18.2%',
                angle: 310,
                emit: true,
            },
            {
                x: '68.3%',
                y: '18.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '68.8%',
                y: '18.8%',
                angle: 310,
                emit: false,
            },
            {
                x: '68.8%',
                y: '18.6%',
                angle: 310,
                emit: true,
            },
        ],
    },

    pumperDad2: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '16%',
            y: '11%',
        },
        texture: 'sprite:/img/partials/pumpers/family/dad/2.json',
        particles: [
            {
                x: '68.9%',
                y: '17.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '69.1%',
                y: '17.5%',
                angle: 310,
                emit: true,
            },
            {
                x: '69%',
                y: '17.8%',
                angle: 310,
                emit: false,
            },
            {
                x: '69%',
                y: '17.8%',
                angle: 310,
                emit: true,
            },
            {
                x: '68.8%',
                y: '17.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '68.6%',
                y: '17.6%',
                angle: 310,
                emit: true,
            },
            {
                x: '69.7%',
                y: '17.8%',
                angle: 310,
                emit: false,
            },
            {
                x: '68.9%',
                y: '17.4%',
                angle: 310,
                emit: true,
            },
            {
                x: '69.1%',
                y: '17.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '68.7%',
                y: '17.3%',
                angle: 310,
                emit: true,
            },
            {
                x: '68.5%',
                y: '19%',
                angle: 310,
                emit: false,
            },
        ],
    },

    pumperDad3: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '16%',
            y: '11%',
        },
        texture: 'sprite:/img/partials/pumpers/family/dad/3.json',
        particles: [
            {
                x: '64%',
                y: '16.2%',
                angle: 310,
                emit: false,
            },
            {
                x: '62.5%',
                y: '16.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '62.3%',
                y: '16.5%',
                angle: 310,
                emit: true,
            },
            {
                x: '61.6%',
                y: '16.2%',
                angle: 310,
                emit: false,
            },
            {
                x: '62.8%',
                y: '16.3%',
                angle: 310,
                emit: true,
            },
            {
                x: '61%',
                y: '16.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '60.7%',
                y: '16.6%',
                angle: 310,
                emit: true,
            },
            {
                x: '65%',
                y: '16.9%',
                angle: 310,
                emit: false,
            },
            {
                x: '64.5%',
                y: '16.8%',
                angle: 310,
                emit: true,
            },
            {
                x: '65.2%',
                y: '15.8%',
                angle: 310,
                emit: false,
            },
            {
                x: '63.5%',
                y: '15.3%',
                angle: 310,
                emit: true,
            },
            {
                x: '63.7%',
                y: '16.1%',
                angle: 310,
                emit: false,
            },
            {
                x: '63%',
                y: '15.9%',
                angle: 310,
                emit: true,
            },
        ],
    },

    dadPump: {
        scale: {
            x: '100%',
        },
        position: {
            x: '16%',
            y: '11%',
        },
        texture: '/img/partials/pumpers/family/pump.png',
    },

    familyPumpBg: {
        scale: {
            x: '100%',
        },
        texture: '/img/partials/pumpers/family/bg.jpg',
    },

    mom1: {
        type: 'movieclip',
        scale: {
            x: '88%',
        },
        position: {
            x: '2%',
            y: '15%',
        },
        texture: `sprite:/img/partials/pumpers/family/mom-${prefix}.json,mom/1`,
    },

    mom2: {
        type: 'movieclip',
        scale: {
            x: '88%',
        },
        position: {
            x: '2%',
            y: '15%',
        },
        texture: `sprite:/img/partials/pumpers/family/mom-${prefix}.json,mom/2`,
    },

    mom3: {
        type: 'movieclip',
        scale: {
            x: '88%',
        },
        position: {
            x: '2%',
            y: '15%',
        },
        texture: `sprite:/img/partials/pumpers/family/mom-${prefix}.json,mom/3`,
    },

    momLandau: {
        scale: {
            x: '88%',
        },
        position: {
            x: '2%',
            y: '15%',
        },
        texture: '/img/partials/pumpers/family/landau.png',
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/dadPump.js